import React from 'react';

import {
  useNavigate,
  useParams,
} from "react-router-dom";

export const withRouter = (WrappedComponent) => {
  function WithRouter(props) {
    const params = useParams();
    const navigate = useNavigate();

    return <WrappedComponent {...props} params={params} navigate={navigate} />;
  }

  return WithRouter;
};

